<div class="modal fade" tabindex="-1" role="dialog" id="bonificacao-filtro">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 translate class="modal-title">{{'parametros.bonificacao.filtros.definirFiltros'}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container striped-rows">
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'parametros.bonificacao.filtros.id'}}
            </div>
            <div class="col col-8">
              <input class="form-control form-control-sm" type="number"
                placeholder="{{'parametros.bonificacao.filtros.idPlaceHolder' | translate}}" [(ngModel)]="filtros.id">
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'parametros.bonificacao.filtros.descricao'}}
            </div>
            <div class="col col-8">
              <input class="form-control form-control-sm" type="text"
                placeholder="{{'parametros.bonificacao.filtros.descricaoPlaceHolder' | translate}}"
                [(ngModel)]="filtros.descricao">
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="filtros.id = '' || filtros.descricao = ''">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
        <button type="button" class="btn btn-info" data-dismiss="modal">OK</button>
      </div>
    </div>
  </div>
</div>